import React from 'react'

import { SiteContext } from 'context/site-context'

import {
  getZip,
} from 'helpers'

import BannerAd from 'components/atoms/BannerAd'

import GEICO_AGENTS from './geico_listings_active'

import './index.scss'

const GeicoBanner = props => {
  const [ site, setSite ] = React.useContext(SiteContext)

  const [ agent, setAgent ] = React.useState()

  // React.useEffect( () => {
  //   const zip = getZip(site.zip_code)

  //   if(zip){
  //     const agents = GEICO_AGENTS.filter( agent => {
  //       const isValid = (agent.POSTAL_TARGETS.indexOf(zip) > -1) && (props.profileId ? agent.LISTING_ID !== props.profileId : true)
  //       return isValid
  //     })
  //     setAgent( agents.length > 0 ? {
  //       result: {
  //         name: agents[0].LISTING_NAME,
  //         phone_number: agents[0].PHONE,
  //         id: agents[0].LISTING_ID,
  //         address: {
  //           street: agents[0].STREET_ADDRESS,
  //           city: agents[0].CITY,
  //           state: agents[0].STATE_OR_PROVINCE,
  //           postal_code: agents[0].POSTAL_CODE,
  //         },
  //         image: 'https://s3.amazonaws.com/assets.elocal.com/sem/assets/images/citysearch/geico_local_office.jpeg',
  //       }
  //     } : null)
  //   }
  // }, [setAgent, site.zip_code])

  return agent ? <div className="geico-banner-container">
    <h4>Your Local <span className="highlight">Geico Insurance Agent</span></h4>
    <BannerAd {...agent} />
  </div> : null
}

export default GeicoBanner
